import React from "react";
import Reveal from "@/components/site/Reveal";

export default function SectionHeading({ overline, title, subtitle, align = "left", className = "" }) {
  const alignment = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <Reveal className={`flex max-w-2xl flex-col ${alignment} ${className}`}>
      {overline && <span className="overline mb-4">{overline}</span>}
      <h2 className="font-heading text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title}
      </h2>
      {subtitle && <p className="mt-5 text-base leading-relaxed text-slate-400 sm:text-lg">{subtitle}</p>}
    </Reveal>
  );
}
